import * as React from 'react'

import { usePostTemplates } from '~publish/pages/Create/Templates/hooks/usePostTemplates'
import type { Template } from '~publish/pages/Create/Templates/types'

export const useFilteredTemplates = (
  count: number,
): { templates: Template[]; loading: boolean } => {
  const { templates, loading } = usePostTemplates()

  const filteredTemplates = React.useMemo(() => {
    const filtered = templates.filter(
      (template) => template.type !== 'Behind the Scenes',
    )

    if (filtered.length <= count) return filtered

    const shuffled = filtered.toSorted(() => 0.5 - Math.random())
    return shuffled.slice(0, count)
  }, [templates, count])

  return { templates: filteredTemplates, loading }
}
